export interface FormClient {
  phone: string;
  postPaidCardType: PostPaidCardType;
}

export enum PostPaidCardType {
  post_paid = 'POST_PAID',
  pre_paid = 'PRE_PAID',
}
